/**
 *
 * @/functions/device.js
 *
 */

//
// IMPORTS
//

import { escapeXML } from "@/functions/miscellaneous"
import { version, PARTNER } from '@/constants'

//
//
//

// https://caniuse.com/?search=userAgentData
// https://caniuse.com/?search=getHighEntropyValues

export const getDeviceForPing = async () => {
  const ua = navigator.userAgentData

  let osname = ""
  let osvers = ""
  let browsers = []

  if (ua && ua.getHighEntropyValues) {
    try {
      const high = await ua.getHighEntropyValues(["fullVersionList", "platform", "platformVersion"]);

      if (high.platform) osname = high.platform
      if (high.platformVersion) osvers = high.platformVersion

      if (Array.isArray(high.fullVersionList)) {
        browsers = high.fullVersionList.map(item => {
          const brand = String(item?.brand || "").trim()
          const version = String(item?.version || "").trim()
          if (brand && version) return `${brand} ${version}`
          if (brand && !version) return brand
          if (!brand && version) return version
          return null
        })
      }
    } catch (e) {
      // fallback automático
      osname = ""
      osvers = ""
      browsers = []
    }
  }

  // Caso fullVersionList não exista, usar brands
  if (!browsers.length && ua && Array.isArray(ua.brands)) {
    browsers = ua.brands.map(item => {
      const brand = String(item?.brand || "").trim()
      const version = String(item?.version || "").trim()
      if (brand && version) return `${brand} ${version}`
      if (brand && !version) return brand
      if (!brand && version) return version
      return null
    })
  }

  //
  //
  //

  let tz = ""
  try {
    tz = String(Intl.DateTimeFormat().resolvedOptions().timeZone || "").trim()
  } catch {}

  const platform = String(navigator?.userAgentData?.platform || "").trim()

  const xml = []
  if (version) xml.push(`<appvers>${version}</appvers>`)
  xml.push(`<whitelabel>${PARTNER}</whitelabel>`)
  if (!osname && platform && platform.toLowerCase() !== "unknown") xml.push(`<platform>${escapeXML(platform)}</platform>`)
  if (osname) xml.push(`<osname>${escapeXML(osname)}</osname>`)
  if (osvers) xml.push(`<osvers>${escapeXML(osvers)}</osvers>`)
  if (browsers.length) xml.push(`<browsers>${escapeXML(browsers.join(" - "))}</browsers>`)
  if (navigator.userAgent) xml.push(`<ua>${escapeXML(navigator.userAgent)}</ua>`)
  if (screen.width) xml.push(`<nav_screenw>${escapeXML(screen.width)}</nav_screenw>`)
  if (screen.height) xml.push(`<nav_screenh>${escapeXML(screen.height)}</nav_screenh>`)
  if (tz) xml.push(`<tz>${escapeXML(tz)}</tz>`)
  if (navigator.platform) xml.push(`<nav_platform>${escapeXML(navigator.platform)}</nav_platform>`)
  if (navigator.vendor) xml.push(`<vendor>${escapeXML(navigator.vendor)}</vendor>`)

  //
  // Gerar XML simples
  //

  return xml.join("")
}
